import React from 'react';
import { FaInfoCircle, FaCalculator, FaCashRegister, FaTags, FaMoneyBillWave, FaChartLine, FaShoppingCart } from 'react-icons/fa';
import { FiPrinter, FiCreditCard } from 'react-icons/fi';
import './InfoSection.scss';

interface InfoSectionProps {}

const InfoSection: React.FC<InfoSectionProps> = () => {
  return (
    <div className="info-section">
      {/* Main Title Section */}
      <div className="section-title">
        <FaInfoCircle className="section-icon" />
        ¿Qué es un arqueo de caja?
      </div>
      
      {/* Definition Card */}
      <div className="definition-card">
        <p>
          Proceso de verificación y conciliación de los ingresos obtenidos durante un turno de trabajo, 
          asegurando que el total de dinero en efectivo y otros medios de pago coincida con los registros del sistema.
        </p>
      </div>

      {/* Process Overview Cards */}
      <div className="process-overview">
        <div className="overview-title">Descripción de Campos</div>
        <div className="process-grid">
          <div className="process-card">
            <div className="process-header">
              <div className="process-icon">
                <FaChartLine />
              </div>
              <div className="process-title">Resumen de Transacciones</div>
            </div>
            <div className="process-description">
              Detalle de todos los pagos procesados durante el turno, desglosado por categorías, cajas y propinas.
            </div>
          </div>

          <div className="process-card">
            <div className="process-header">
              <div className="process-icon">
                <FiCreditCard />
              </div>
              <div className="process-title">Totales por Categoría</div>
            </div>
            <div className="process-description">
              Suma de los pagos procesados, clasificados por tipo de pago (crédito, débito, efectivo).
            </div>
          </div>

          <div className="process-card">
            <div className="process-header">
              <div className="process-icon">
                <FaCashRegister />
              </div>
              <div className="process-title">Detalle Cajas</div>
            </div>
            <div className="process-description">
              Registro de movimientos de cada caja operativa, permitiendo control individualizado.
            </div>
          </div>

          <div className="process-card">
            <div className="process-header">
              <div className="process-icon">
                <FaMoneyBillWave />
              </div>
              <div className="process-title">Detalle Propinas</div>
            </div>
            <div className="process-description">
              Registro del monto total de propinas acumuladas, separadas por efectivo y tarjeta.
            </div>
          </div>
        </div>
      </div>

      {/* Technical Vocabulary */}
      <div className="vocabulary-section">
        <div className="vocabulary-title">Vocabulario Técnico</div>
        <div className="vocabulary-grid">
          <div className="vocabulary-card">
            <div className="vocabulary-header">
              <div className="vocabulary-icon">
                <FiPrinter />
              </div>
              <div className="vocabulary-term">Terminal POS</div>
            </div>
            <div className="vocabulary-definition">
              Identificador del dispositivo donde se procesa un pago. Permite asociar transacciones a terminales específicas.
            </div>
          </div>

          <div className="vocabulary-card">
            <div className="vocabulary-header">
              <div className="vocabulary-icon">
                <FaShoppingCart />
              </div>
              <div className="vocabulary-term">Balance Inicial</div>
            </div>
            <div className="vocabulary-definition">
              Monto de dinero en caja al inicio del turno, base para el arqueo y control de ingresos.
            </div>
          </div>

          <div className="vocabulary-card">
            <div className="vocabulary-header">
              <div className="vocabulary-icon">
                <FaTags />
              </div>
              <div className="vocabulary-term">Total Movimientos</div>
            </div>
            <div className="vocabulary-definition">
              Suma de todos los ingresos y transacciones registradas durante el turno operativo.
            </div>
          </div>

          <div className="vocabulary-card">
            <div className="vocabulary-header">
              <div className="vocabulary-icon">
                <FaCalculator />
              </div>
              <div className="vocabulary-term">Diferencia Total</div>
            </div>
            <div className="vocabulary-definition">
              Resultado final del arqueo. Debe ser $0 para indicar que no hay desajustes en los registros.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
